import {v1} from 'uuid';

export const getUuid = v1;
